<h1 mat-dialog-title>Selecteer voorraad voor navigatie</h1>
<div mat-dialog-content>
  <div *ngFor="let stock of stocks" class="stock-item">
    <div class="stock-info">
      <h3>{{ stock.plantName }}</h3>
      <p>Locatie: {{ stock.location }}</p>
    </div>
    <button mat-raised-button color="primary" (click)="onSelectStock(stock.id)">Selecteer</button>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuleren</button>
</div>
